const cloud_flare_img = (path) => (`https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/${path}/original   `)


const examsDistrictAdminLogo = cloud_flare_img('75b02511-73fb-4e43-facc-10e36a181400');
const reportsDistrictAdminLogo = cloud_flare_img('8eca787f-7fc7-4158-517f-f7586503fc00');

export {
    examsDistrictAdminLogo,
    reportsDistrictAdminLogo
}